export default (dc, label, type, config) => {
  const defaultType = dc.getType('default');
  const defaultModel = defaultType.model;
  dc.addType(type, {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          icon: '<i class="wb webconnect-list-task"></i>',
          'custom-name': label,
          droppable: false, // Can't drop other elements inside
          script: function () {
            if (typeof renderPageListComponent !== 'undefined') {
              renderPageListComponent(this);
            }
          },
        },
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') === type) {
            return {
              type: type,
            };
          }
        },
      },
    ),
  });
};
